<p>control-panel works!</p>
<div class="flex justify-end my-4">
    <button class="text-gray-600 p-2 rounded-md font-bold"(click)="goBack()">BACK</button>
  </div>